<template>
  <div class="app-change-personal-data">
    <slot name="beforePersonalData">Persönliche Daten</slot>
    <b-form
      :id="'form' + _uid"
      :novalidate="true"
      form-personal-data-input>
      <b-row class="salution">
        <b-col md="" sm="12" class="label">
          <slot name="labelSalutation"> Anrede</slot>
        </b-col>
        <b-col md="" sm="12" class="value">{{currentCustomer.salutation}}</b-col>
      </b-row>
      <b-row class="lastName">
        <b-col md="" sm="12" class="label">
          <slot name="labelLastName">Nachname</slot>
        </b-col>
        <b-col md="" sm="12" class="value">{{currentCustomer.lastName}}</b-col>
      </b-row>
      <b-row class="firstName">
        <b-col md="" sm="12" class="label">
          <slot name="labelFirstName">Vorname</slot>
        </b-col>
        <b-col md="" sm="12" class="value">{{currentCustomer.firstName}}</b-col>
      </b-row>
      <b-form-group class="street-group">
        <b-row class="streetNumber">
          <b-col md="" sm="12" class="label">
            <label class="mandatory">  <slot name="labelStreetNumber">Straße / <abbr title="Hausnummer">Hausnr.</abbr></slot></label>
          </b-col>
          <b-col md="" sm="12" class="street">
            <b-form-input
              name="street"
              type="text"
              v-model="currentCustomer.address.street"
              required
              @input="$v.currentCustomer.address.street.$touch"
              :state="isValid('street','address','currentCustomer')"
            ></b-form-input>
          </b-col>
          <b-col md="" sm="12" class="houseNumber">
            <b-form-input
              name="houseNumber"
              type="text"
              v-model="currentCustomer.address.houseNumber"
              required
              @input="$v.currentCustomer.address.houseNumber.$touch"
              :state="isValid('houseNumber','address','currentCustomer')"
            ></b-form-input>
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group class="zip-group">
        <b-row class="zipCity">
          <b-col md="" sm="12" class="label">
            <label class="mandatory"><slot name="labelZipCity"><abbr title="Postleitzahl"><span class="uppercase">plz</span></abbr> / Ort</slot></label>
          </b-col>
          <b-col md="" sm="12" class="zip">
            <b-form-input
              name="zip"
              type="text"
              v-model="currentCustomer.address.zip"
              required
              @input="$v.currentCustomer.address.zip.$touch"
              :state="isValid('zip', 'address','currentCustomer')"
            ></b-form-input>
          </b-col>
          <b-col md="" sm="12" class="city">
            <b-form-input
              name="city"
              type="text"
              v-model="currentCustomer.address.city"
              required
              @input="$v.currentCustomer.address.city.$touch"
              :state="isValid('city', 'address','currentCustomer')"
            ></b-form-input>
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group class="supplement-group">
        <b-row class="supplement">
          <b-col md="" sm="12" class="label">
            <label><slot name="labelSupplement">Adresszusatz</slot></label>
          </b-col>
          <b-col md="" sm="12">
            <b-form-input
              name="supplement"
              type="text"
              v-model="currentCustomer.address.supplement"
            ></b-form-input>
          </b-col>
        </b-row>
      </b-form-group>
      <b-row class="birthDate">
        <b-col md="" sm="12" class="label">
          <slot name="labelBirthDate">Geburtsdatum</slot>
        </b-col>
        <b-col md="" sm="12" class="value">{{currentCustomer.birthDate}}</b-col>
      </b-row>
      <b-form-group class="email-group">
        <b-row>
          <b-col md="" sm="12" class="label">
            <label class="mandatory"><slot name="labelEmail">E-Mail Addresse</slot></label>
          </b-col>
          <b-col md="" sm="12">
            <b-form-input
              name="email"
              type="email"
              required
              @input="$v.currentCustomer.email.$touch"
              :state="isValid('email', 'currentCustomer')"
              v-model="currentCustomer.email"
              aria-describedby="email-live-feedback"
            ></b-form-input>
            <b-form-invalid-feedback id="email-live-feedback">
              <slot v-if="$v.currentCustomer.email.email === false" name="emailLiveFeedback">
                keine richtige E-Mail-Adresse
              </slot>
            </b-form-invalid-feedback>
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group class="email-repeat-group">
        <b-row class="email">
          <b-col md="" sm="12" class="label">
            <label class="mandatory"><slot name="emailRepeatLabel">E-Mail-Adresse wiederholen</slot></label>
          </b-col>
          <b-col md="" sm="12">
            <b-form-input
              name="email-repeat"
              type="email"
              required
              @input="$v.emailRepeat.$touch"
              :state="isValid('emailRepeat')"
              v-model="emailRepeat"
              aria-describedby="email-repeat-live-feedback"
            ></b-form-input>
            <b-form-invalid-feedback id="email-repeat-live-feedback">
              <slot v-if="$v.emailRepeat.sameAsEmail === false" name="emailRepeatLiveFeedback">
                E-Mail-Adresse nicht identisch
              </slot>
            </b-form-invalid-feedback>
          </b-col>
        </b-row>
      </b-form-group>
    </b-form>
    <Stepper
      @next="save()"
      :loading-next="loading"
      @prev="backView()"
      :disabled-next="$v.$invalid || loading"
    >
      <template v-for="slot in possibleChildSlotsFor('Stepper')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </Stepper>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import { BForm, BFormInput, BRow, BCol, BFormGroup, BFormInvalidFeedback } from 'bootstrap-vue'
import { validationMixin } from 'vuelidate'
import { wrapQuery } from '../../../../helper/wrapGQLQuery'
import gql from 'graphql-tag'
import { email, required, sameAs } from 'vuelidate/lib/validators'
import { validZipCode, validCityString } from '@/validators/address'
import isValid from '../../../../mixins/isValid'
import Stepper from '../../../generic/Stepper.vue'
import slotProxy from '@/mixins/slotProxy'

export const stepName = 'changePersonalData'
export default {
  name: 'ChangePersonalData',
  data () {
    return {
      currentCustomer: {
        salutation: '',
        firstName: '',
        lastName: '',
        birthDate: '',
        address: {
          city: '',
          houseNumber: '',
          street: '',
          supplement: '',
          zip: ''
        },
        email: ''
      },
      emailRepeat: '',
      loading: false
    }
  },
  components: {
    BFormInput, BForm, BRow, BCol, BFormGroup, BFormInvalidFeedback, Stepper
  },
  methods: {
    ...mapMutations('personalData', [
      'changeView'
    ]),
    ...mapActions('personalData', [
      'changePersonalData'
    ]),
    save () {
      this.loading = true
      this.changePersonalData(this.currentCustomer).then(() => {
        this.loading = false
      }, () => {
        this.loading = false
      })
    },
    backView () {
      this.changeView('viewPersonalData')
    },
    setEmailRepeat (data) {
      this.emailRepeat = data.email
    }
  },
  mixins: [
    validationMixin,
    isValid,
    slotProxy()
  ],
  validations () {
    return {
      currentCustomer: {
        address: {
          street: {
            required
          },
          houseNumber: {
            required
          },
          zip: {
            validZipCode,
            required
          },
          city: {
            validCityString,
            required
          }
        },
        email: {
          required,
          email
        }
      },
      emailRepeat: {
        required,
        email,
        sameAsEmail: sameAs(function () { return this.currentCustomer.email })
      }
    }
  },
  apollo: {
    currentCustomer: function () {
      const me = this
      return wrapQuery(
        gql`query personalData {
          currentCustomer {
            salutation,
            firstName,
            birthDate,
            lastName,
            address {
              city,
              houseNumber,
              street,
              supplement,
              zip
            },
            email
          }
        }`, this, 'currentCustomer', {},
        function (data) {
          me.setEmailRepeat(data)
        },
        {
          fetchPolicy: 'cache-first'
        }
      )
    }
  }
}
</script>
